<template>
  <section class="notifications navbar-notifications">
    <header class="cardHeader card-header">
      <div class="text-center mb-sm">
        <strong>Tem {{CountNewNotifications}} notificações</strong>
      </div>
      <!-- 
      <b-button-group id="notification-b-buttons">
        <b-button variant="default" @click="changeNotificationsTab(1)">Notifications</b-button>
        <b-button variant="default" @click="changeNotificationsTab(2)">Messages</b-button>
        <b-button variant="default" @click="changeNotificationsTab(3)">Progress</b-button>
      </b-button-group> 
      -->
    </header>
      <!-- <NewNotifictionsList v-if="newNotifications" /> -->
      <!-- <NotifictionsList v-else-if="notificationsTabSelected === 1" />
      <Messages v-else-if="notificationsTabSelected === 2" />
      <Progress v-else-if="notificationsTabSelected === 3" /> -->
    <NotificationsList :notificationList='newNotifications' @click="clickCallback"/>
    <footer class="cardFooter text-sm card-footer">
      <!-- <span class="fs-mini">Synced at: 21 Apr 2014 18:36</span> -->
      <b-button
        variant="link"
        @click="loadNotifications"
        :class="{disabled: isLoad, 'btnNotificationsReload btn-xs float-right py-0': true}"
      >
        <span v-if="isLoad"><i class="la la-refresh la-spin" /> Loading...</span>
        <i v-else class="la la-refresh" />
      </b-button>
    </footer>
  </section>
</template>

<script>
import Vue from 'vue';

import NotificationsList from './NotificationsDemo/NotificationsList';
// import NewNotifictionsList from './NotificationsDemo/NewNotificationsList';
// import Messages from './NotificationsDemo/Messages';
// import Progress from './NotificationsDemo/Progress';

export default {
  name: 'Notification',
  components: {
    // NotifictionsList, NewNotifictionsList, Messages, Progress,
    NotificationsList
  },
  data() {
    return {
      notificationsTabSelected: 1,
      newNotifications: [],
      isLoad: false,
    };
  },
  mounted(){
    // console.log('notificações ativas');
    this.loadNotifications();
  },
  computed: {

    CountNewNotifications(){
      var novos = this.newNotifications.filter((n) => {return n.is_seen == 0 });
      return novos.length;
      // return this.newNotifications.length;
    }

  },
  watch: {
        'newNotifications': function(){
            this.$emit("updateBadge", this.CountNewNotifications);
        },
  },
  methods: {
    clickCallback(ev){
      console.log(ev);


      this.$router.push(ev.link);
    },
    changeNotificationsTab(tab) {
      Vue.set(this, 'notificationsTabSelected', tab);
      // Vue.set(this, 'newNotifications', null);
    },
    loadNotifications() {
      let self = this;
      self.isLoad = true;
      this.api.post('Sys/Notifications/list/').then(function(response){
        
          if(response.dados.length > 0){
            self.newNotifications = response.dados;
          }
          self.isLoad = false;
      });
    },
  },
};
</script>

<style src="./Notifications.scss" lang="scss" />